export const CoreCustomersByIdUsersName = 'CoreCustomersByIdUsers';
